if (!customElements.get('product-card')) {

  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
      
      // Add click event listeners for product group swatches
      const productGroupSwatches = this.querySelectorAll('[product_group_swatch] [color_swatch_product]');
      productGroupSwatches.forEach((span) => {
        span.addEventListener('click', this.onProductGroupSwatchHover.bind(this));
      });
    }

    onSwatchClick(event) {
      const swatch = event.target;
      const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
      const swatchImageElement = swatch.querySelector('.data-variant-image');
      const newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
      const newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;

      this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
      swatch.classList.add('selected');

      if (productImage && swatchImageElement) {
        productImage.src = newImageUrl;
        productImage.srcset = newSrcset;
      }
    }

    onProductGroupSwatchHover(event) {
      const hoveredSpan = event.target;
      const productUrl = hoveredSpan.getAttribute('data-product-url');
      const productId = hoveredSpan.getAttribute('data-product-id');
      const productImageUrl = hoveredSpan.getAttribute('data-product-image');
      const productPrice = hoveredSpan.getAttribute('data-product-price');
      const cardMediaLink = this.querySelector('a.card-media');
      const productImage = this.querySelector('.card-media-child img');
      const priceElement = this.querySelector('.price__regular .price-item');
      const ModelOpner = this.querySelector('modal-opener');
      const QuickSubmitButton = this.querySelector('.quick-add__submit');
      const productAvailable = hoveredSpan.getAttribute('data-product-available');
      const ProductBadge = this.querySelector('.card__badge span');
      
      if (productUrl && cardMediaLink) {
        cardMediaLink.href = productUrl;
        QuickSubmitButton.setAttribute('data-product-url', productUrl);
      }

      if (productAvailable === 'true' && ProductBadge) {
        if (ProductBadge.textContent === 'Sold out') {
          ProductBadge.style.display = 'none';
        }
      }else if (productAvailable === 'false') {
        ProductBadge.style.display = 'inline-block';
      }

      if (ModelOpner) {
        ModelOpner.setAttribute('data-modal', `#QuickAdd-${productId}`);
      }
      
      if (productImageUrl && productImage) {
        productImage.src = productImageUrl;
        productImage.srcset = '';
      }
      
      if (productPrice && priceElement) {
        priceElement.textContent = productPrice;
      }
    }
  }

  customElements.define('product-card', ProductCard);
}